import React from 'react'
import styles from './checkbox.module.scss'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const Checkbox = ({
  onChangeHandle,
  className = '',
  bgClassName = '',
  ...rest
}) => (
  <label className={clsx(styles['checkbox'], className)}>
    <input
      className={styles['checkbox__element']}
      type="checkbox"
      onChange={onChangeHandle}
      onTouchEnd={onChangeHandle}
      {...rest}
    />
    <span className={clsx(styles['checkbox__bg'], bgClassName)} />
  </label>
)

export default Checkbox

Checkbox.propTypes = {
  onChangeHandle: PropTypes.func,
  className: PropTypes.string,
  bgClassName: PropTypes.string,
  rest: PropTypes.object,
}
